export default "__VITE_ASSET__92ab1841__"